<template>
  <div>

    <div :class="userFlag ? 'contextUser' : 'context'">
      <a-row style="padding: 20px 20px"  :gutter="[16,16]">
        <!-- 性别 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('user.tableHeader.sex')}}</span>
          <span class="valueName">{{$t('user.sex.'+userInfo.sex)}}</span>
        </a-col>
        <!-- 入职时间 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('user.tableHeader.entrytime')}}</span>
          <span class="valueName">{{userInfo.entrytime}}</span>
        </a-col>
        <!-- 所属部门 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('user.tableHeader.depId')}}</span>
          <span class="valueName">{{userInfo.depName}}</span>
        </a-col>
        <!-- 所属职位 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('user.tableHeader.postId')}}</span>
          <span class="valueName">{{userInfo.postName}}</span>
        </a-col>
        <!-- 最高学历 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.highestEducation')}}</span>
          <span class="valueName">{{userInfo.education}}</span>
        </a-col>
        <!-- 生日 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.birthday')}}</span>
          <span class="valueName">{{moment(userInfo.birthTime).format('MM-DD')}}({{$t('user.birthType.'+userInfo.birthtype)}})</span>
        </a-col>
        <!-- 系统登录名 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('user.modal.loginName')}}</span>
          <span class="valueName">{{userInfo.accountDO.loginName}}</span>
        </a-col>
        <!-- 邮箱 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('user.tableHeader.email')}}</span>
          <span class="valueName">
            <a-tooltip :title="userInfo.mail" placement="top">
              {{userInfo.mail}}
            </a-tooltip>

          </span>
        </a-col>
        <!-- 合同到期日 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('user.tableHeader.contractExpiry')}}</span>
          <span class="valueName">{{userInfo.contractExpiry}}</span>
        </a-col>
        <!-- 实习期 -->
        <a-col :span="6" class="colName">
          <div class="labelName">{{$t('user.tableHeader.trialdate')}}</div>
          <div class="valueName">
            <a-tooltip v-if="getArrayList(userInfo.trialdate) != '~'" :title="getArrayList(userInfo.trialdate)" placement="top">
              {{getArrayList(userInfo.trialdate)}}
            </a-tooltip>
            <span v-else>{{getArrayList(userInfo.trialdate)}}</span>
          </div>
        </a-col>
         <!-- 试用期 -->
        <a-col :span="6" class="colName">
          <div class="labelName">{{$t('user.tableHeader.practicedate')}}</div>
          <div class="valueName">
            <a-tooltip v-if="getArrayList(userInfo.practicedate) != '~'" :title="getArrayList(userInfo.practicedate)" placement="top">
              {{getArrayList(userInfo.practicedate)}}
            </a-tooltip>
            <span v-else>{{getArrayList(userInfo.practicedate)}}</span>
          </div>
        </a-col>
        <!-- 汇报对象 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('user.modal.leader')}}</span>
          <span class="valueName">{{userInfo.reporterName}}</span>
        </a-col>
        <!-- 证件类型 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.idType')}}</span>
          <span class="valueName">{{inductionInfo.idTypeName && inductionInfo.idTypeName !='~' ?inductionInfo.idTypeName:$t('key17shenfenzheng')}}</span>
        </a-col>

        <!-- 证件号码 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.idNumber')}}</span>
          <span class="valueName">
            <a-tooltip  :title="userInfo.idcard" placement="top">
            {{userInfo.idcard}}
            </a-tooltip>
          </span>
        </a-col>

        <!-- 民族 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.nation')}}</span>
          <span class="valueName">{{inductionInfo.inductionBasicDO.nation ? inductionInfo.inductionBasicDO.nation:$t('key17hhanzu')}}</span>
        </a-col>
        <!-- 手机号码 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.phoneNumber')}}</span>
          <span class="valueName">{{userInfo.phone}}</span>
        </a-col>

        <!-- 紧急联系人 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('user.tableHeader.linkmanname')}}</span>
          <span class="valueName">{{userInfo.linkmanname}}</span>
        </a-col>
        <!-- 关系 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionFamily.relationship')}}</span>
          <span class="valueName">{{inductionInfo.relationshipName[0]?inductionInfo.relationshipName[0]:'~'}}</span>
        </a-col>

        <!-- 电话 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('user.tableHeader.linkmanphone')}}</span>
          <span class="valueName">{{userInfo.linkmanphone}}</span>
        </a-col>
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('user.tableHeader.brokerageId')}}</span>
          <span class="valueName">
            <a-tooltip :title="empBrokerageInfo.name" placement="top">
              {{empBrokerageInfo.name}}
            </a-tooltip>
          </span>
        </a-col>
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionTreatment.bank')}}</span>
          <span class="valueName">
<!--            <a-tooltip :title="userInfo.linkmanphone" placement="top">-->
              {{userInfo.blankname}}
<!--            </a-tooltip>-->
          </span>
        </a-col>
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionTreatment.bankAddress')}}</span>
          <span class="valueName">
<!--            <a-tooltip :title="empBrokerageInfo.name" placement="top">-->
              {{userInfo.branch}}
<!--            </a-tooltip>-->
          </span>
        </a-col>
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionTreatment.bankNumber')}}</span>
          <span class="valueName">
<!--            <a-tooltip :title="empBrokerageInfo.blankcode" placement="top">-->
              {{userInfo.blankcode}}
<!--            </a-tooltip>-->
          </span>
        </a-col>

      </a-row>


    </div>


    <!-- 基本资料 ---------------------------------------------------------------------------------------------------------------------->
    <div :class="userFlag ? 'topUser' : 'top'"  >
      <div style="width: 12px;height: 12px;background: #FABE00;border-radius: 50%;margin-left: 9px"></div>
      <div style="font-size: 14px;color: #333333;font-weight: 600;margin-left: 10px">
        {{$t('datapermission.detailInfo')}}
      </div>
    </div>

    <div :class="userFlag ? 'contextUser' : 'context'"   >

      <a-row style="padding: 20px 20px;" :gutter="[16,16]">

        <!-- 婚姻状况 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.maritalStatus')}}</span>
          <span class="valueName">{{inductionInfo.maritalStatusName?inductionInfo.maritalStatusName:'~'}}</span>
        </a-col>
        <!-- 生育状况 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.fertilityStatus')}}</span>
          <span class="valueName">{{inductionInfo.fertilityStatusName?inductionInfo.fertilityStatusName:'~'}}</span>
        </a-col>
        <!-- 籍贯 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.nativePlace')}}</span>
          <span class="valueName">{{getNativeName(inductionInfo.inductionBasicDO.nativePlace)?getNativeName(inductionInfo.inductionBasicDO.nativePlace):'~'}}</span>
        </a-col>
        <!-- 户籍类型 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.registeredType')}}</span>
          <span class="valueName">{{inductionInfo.registeredTypeName?inductionInfo.registeredTypeName:'~'}}</span>
        </a-col>
        <!-- 人员类型 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.personnelType')}}</span>
          <span class="valueName">{{inductionInfo.personnelTypeName?inductionInfo.personnelTypeName:'~'}}</span>
        </a-col>
        <!-- 健康状况 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.healthStatus')}}</span>
          <span class="valueName">{{inductionInfo.healthStatusName?inductionInfo.healthStatusName:'~'}}</span>
        </a-col>

        <!-- 毕业学校 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.graduationSchool')}}</span>
          <span class="valueName">{{inductionInfo.inductionBasicDO.graduationSchool?inductionInfo.inductionBasicDO.graduationSchool:'~'}}</span>
        </a-col>
        <!-- 专业 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.major')}}</span>
          <span class="valueName">{{inductionInfo.inductionBasicDO.major?inductionInfo.inductionBasicDO.major:'~'}}</span>
        </a-col>

        <!-- 首次工作 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.firstWorkingDate')}}</span>
          <span class="valueName">{{inductionInfo.inductionBasicDO.firstWorkingDate != '~'?inductionInfo.inductionBasicDO.firstWorkingDate:'~'}}</span>
        </a-col>
        <!-- 执业资格 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.practiceQualification')}}</span>
          <span class="valueName">{{inductionInfo.inductionBasicDO.practiceQualification?inductionInfo.inductionBasicDO.practiceQualification:'~'}}</span>
        </a-col>
        <!-- 专业职称 -->
        <a-col :span="6" class="colName">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.professionalTitle')}}</span>
          <span class="valueName">{{inductionInfo.inductionBasicDO.professionalTitle?inductionInfo.inductionBasicDO.professionalTitle:'~'}}</span>
        </a-col>
        <!-- 其他技能证书 -->
        <a-col :span="6" class="colName" >
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.certificate')}}</span>
          <div class="valueName" style="width: 100%;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">
            <a-tooltip placement="topLeft" :title="inductionInfo.inductionBasicDO.certificate">
              {{inductionInfo.inductionBasicDO.certificate}}
            </a-tooltip>
          </div>
        </a-col>
        <!-- 身份证地址 -->
        <a-col :span="12" class="colName">
          <div class="labelName" >{{$t('datapermission.induction.inductionBasic.registeredAddress')}}</div>
          <div class="valueName" style=" overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{inductionInfo.inductionBasicDO.registeredAddress?inductionInfo.inductionBasicDO.registeredAddress:'~'}}</div>
        </a-col>
        <!-- 现居住地 -->
        <a-col :span="12" class="colName">
          <div class="labelName">{{$t('datapermission.induction.inductionBasic.addressNow')}}</div>
          <div class="valueName" style=" overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{inductionInfo.inductionBasicDO.addressNow?inductionInfo.inductionBasicDO.addressNow:'~'}}</div>
        </a-col>
        <!-- 健康状况 -->
        <a-col :span="24" class="colName" v-if="inductionInfo.inductionBasicDO.healthStatus == 3">
          <span class="labelName">{{$t('datapermission.induction.inductionBasic.healthStatusRemark')}}</span>
          <span class="valueName">{{inductionInfo.inductionBasicDO.healthStatusRemarks}}</span>
        </a-col>
      </a-row>
    </div>


    <a-collapse   :bordered="false" v-model="activeKey" @change="collapseChanges">

      <!-- 社保公积金工资 ---------------------------------------------------------------------------------------------------------------------->
      <a-collapse-panel  class="panelHeader" key="1" :style="panelStyle" :showArrow="false" >
        <div slot="header" :class="userFlag ? 'copPanelUser' : 'copPanel'">
          <div style="width: 12px;height: 12px;background: #FABE00;border-radius: 50%;margin-left: 9px"></div>
          <div style="font-size: 14px;color: #333333;font-weight: 600;margin-left: 10px;display: flex;justify-content: space-between;width: 100%;align-items: center">
            {{$t('datapermission.induction.treatmentInformation')}}
            <a-icon  type="caret-right" :rotate="activeKey.indexOf('1')>-1  ? 90 : -90" style="margin-right: 16px"/>
          </div>
        </div>
        <div :class="userFlag ? 'copContentUser' : 'copContent'" >
          <a-row style="padding: 30px 20px;" :gutter="[16,16]">
            <!-- 基本工资 -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('user.tableHeader.basepay')}}</span>
              <span class="valueName">{{userInfo.basepay}}</span>
            </a-col>
            <!-- 职位津贴 -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('user.tableHeader.allowance')}}</span>
              <span class="valueName">{{userInfo.allowance}}</span>
            </a-col>
            <!-- 年薪 -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('user.tableHeader.yearSalary')}}</span>
              <span class="valueName">{{yearSalary}}</span>
            </a-col>
            <!-- 入职时长 -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('user.tableHeader.entrytimeLong')}}</span>
              <span class="valueName">{{month}}{{$t('baseVO.month')}}</span>
            </a-col>
            <!-- 公积金账户 -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionTreatment.accumulationFundNumber')}}</span>
              <span class="valueName">{{inductionInfo.inductionTreatmentDO.accumulationFundNumber?inductionInfo.inductionTreatmentDO.accumulationFundNumber:'~'}}</span>
            </a-col>
            <!-- 社保电脑号 -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionTreatment.socialSecurityNumber')}}</span>
              <span class="valueName">{{inductionInfo.inductionTreatmentDO.socialSecurityNumber?inductionInfo.inductionTreatmentDO.socialSecurityNumber:'~'}}</span>
            </a-col>
            <!-- 社保标准 -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('user.tableHeader.registeredResidenceType')}}</span>
              <span class="valueName">{{empInsuranceStandard.name}}</span>
            </a-col>

            <!-- 社保计费基数 -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('user.tableHeader.insuranceBase')}}</span>
              <span class="valueName">{{userInfo.insuranceBase}}</span>
            </a-col>

            <!--失业保险基数 -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('user.tableHeader.unemploymentInsuranceBase')}}</span>
              <span class="valueName">{{userInfo.unemploymentInsuranceBase}}</span>
            </a-col>

          </a-row>

        </div>
      </a-collapse-panel>


      <!-- 主要教育经历 ---------------------------------------------------------------------------------------------------------------------->
      <a-collapse-panel  v-if="inductionInfo.inductionEducationList != '~' && inductionInfo.inductionEducationList.length > 0 " class="panelHeader" key="2" :style="panelStyle" :showArrow="false" >
        <div slot="header" :class="userFlag ? 'copEducationUSer' : 'copEducation'" >
          <div style="width: 12px;height: 12px;background: #FABE00;border-radius: 50%;margin-left: 9px"></div>
          <div style="font-size: 14px;color: #333333;font-weight: 600;margin-left: 10px;display: flex;justify-content: space-between;width: 100%;align-items: center">
            {{$t('datapermission.induction.educationInformationTips')}}
            <a-icon  type="caret-right" :rotate="activeKey.indexOf('2')>-1 ? 90 : -90" style="margin-right: 16px"/>
          </div>
        </div>
        <div :class="userFlag ? 'copEducationContentUser' : 'copEducationContent'"  >
          <a-row style="padding: 28px 0 0 23px">
            <!-- 时间  -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionEducation.educationDate')}}</span>
            </a-col>
            <!-- 学校 -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionEducation.school')}}</span>
            </a-col>
            <!-- 专业 -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionEducation.major')}}</span>
            </a-col>
            <!-- 学历 -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionEducation.education')}}</span>
            </a-col>
          </a-row>
          <a-row style="padding: 10px 0 0 23px" v-for="(item,index) in inductionInfo.inductionEducationList" :key="index">
            <!-- 时间  -->
            <a-col :span="6" class="colName">
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{getEducationDate(item.educationDate)}}</span>
                </template>
                <span class="valueName" >{{getEducationDate(item.educationDate)}}</span>
              </a-tooltip>
            </a-col>
            <!-- 学校 -->
            <a-col :span="6" class="colName">
              <span class="valueName">{{item.school}}</span>
            </a-col>
            <!-- 专业 -->
            <a-col :span="6" class="colName">
              <span class="valueName">{{item.major}}</span>
            </a-col>
            <!-- 学历 -->
            <a-col :span="6" class="colName">
              <span class="valueName">{{item.education}}</span>
            </a-col>
          </a-row>
        </div>
      </a-collapse-panel>

      <!-- 主要工作经历 ---------------------------------------------------------------------------------------------------------------------->
      <a-collapse-panel v-if="inductionInfo.inductionWorkList != '~' && inductionInfo.inductionWorkList.length > 0 "  class="panelHeader" key="3" :style="panelStyle" :showArrow="false" >
        <div slot="header" :class="userFlag ? 'copEducationUSer' : 'copEducation'">
          <div style="width: 12px;height: 12px;background: #FABE00;border-radius: 50%;margin-left: 9px"></div>
          <div style="font-size: 14px;color: #333333;font-weight: 600;margin-left: 10px;display: flex;justify-content: space-between;width: 100%;align-items: center">
            {{$t('datapermission.induction.workInformation')}}
            <a-icon  type="caret-right" :rotate="activeKey.indexOf('3')>-1 ? 90 : -90" style="margin-right: 16px"/>
          </div>
        </div>
        <div :class="userFlag ? 'copEducationContentUser' : 'copEducationContent'" >
          <a-row style="padding: 28px 0 0 23px" >
            <!-- 时间  -->
            <a-col :span="5" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionWork.workDate')}}</span>
            </a-col>
            <!-- 单位 -->
            <a-col :span="5" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionWork.companyNames')}}</span>
            </a-col>
            <!-- 部门 -->
            <a-col :span="5" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionWork.department')}}</span>
            </a-col>
            <!-- 职务 -->
            <a-col :span="5" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionWork.post')}}</span>
            </a-col>
            <!-- 证明人 -->
            <a-col :span="4" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionWork.witnessContact')}}</span>
            </a-col>
          </a-row>
          <a-row style="padding: 10px 0 0 23px" v-for="(item,index) in inductionInfo.inductionWorkList" :key="index">
            <!-- 时间  -->
            <a-col :span="5" class="colName">
              <span class="valueName">{{item.workDate}}</span>
            </a-col>
            <!-- 单位 -->
            <a-col :span="5" class="colName">
              <span class="valueName">{{item.companyName}}</span>
            </a-col>
            <!-- 部门 -->
            <a-col :span="5" class="colName">
              <span class="valueName">{{item.department}}</span>
            </a-col>
            <!-- 职务 -->
            <a-col :span="5" class="colName">
              <span class="valueName">{{item.post}}</span>
            </a-col>
            <!-- 证明人 -->
            <a-col :span="4" class="colName">
              <span class="valueName">{{item.witnessContact}}</span>
            </a-col>
          </a-row>
        </div>
      </a-collapse-panel>


      <!-- 家庭成员 ---------------------------------------------------------------------------------------------------------------------->
      <a-collapse-panel v-if="inductionInfo.inductionFamily != '~' && inductionInfo.inductionFamily.length > 0 "  class="panelHeader" key="4" :style="panelStyle" :showArrow="false" >
        <div slot="header" :class="userFlag ? 'copEducationUSer' : 'copEducation'">
          <div style="width: 12px;height: 12px;background: #FABE00;border-radius: 50%;margin-left: 9px"></div>
          <div style="font-size: 14px;color: #333333;font-weight: 600;margin-left: 10px;display: flex;justify-content: space-between;width: 100%;align-items: center">
            {{$t('datapermission.induction.familyInformations')}}
            <a-icon  type="caret-right" :rotate="activeKey.indexOf('4')>-1 ? 90 : -90" style="margin-right: 16px"/>
          </div>
        </div>
        <div :class="userFlag ? 'copEducationContentUser' : 'copEducationContent'" >
          <a-row style="padding: 15px 0 0 23px" >
            <!-- 姓名  -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionFamily.name')}}</span>
            </a-col>
            <!-- 关系 -->
            <a-col :span="4" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionFamily.relationship')}}</span>
            </a-col>
            <!-- 工作单位 -->
            <a-col :span="6" class="colName">
              <span class="labelName">{{$t('datapermission.induction.inductionFamily.companyPost')}}</span>
            </a-col>
            <!-- 联系方式 -->
            <a-col :span="8"  class="colName">

              <span class="labelName">{{$t('datapermission.induction.inductionFamily.contactInformation')}}</span>
              <div style="display: flex;flex-direction: row">

              </div>
            </a-col>
          </a-row>
          <a-row style="padding: 10px 0 0 23px" v-for="(item,index) in inductionInfo.inductionFamily" :key="index">
            <!-- 姓名  -->
            <a-col :span="6" class="colName">
              <span class="valueName">{{item.name}}</span>
            </a-col>
            <!-- 关系 -->
            <a-col :span="4" class="colName">
              <span class="valueName">{{inductionInfo.relationshipName[index]?inductionInfo.relationshipName[index]:'~'}}</span>
            </a-col>
            <!-- 工作单位 -->
            <a-col :span="6" class="colName">
              <span class="valueName">{{item.companyPost}}</span>
            </a-col>
            <!-- 联系方式 -->
            <a-col :span="8"  class="colName">

              <div style="display: flex;flex-direction: row">
                <span class="valueName" style="width: auto">{{item.contactInformation}}</span>
                <div v-if="item.emergencyContact == 1 " :class="userFlag? 'phoneUser' : 'phone'" >
                  <div style="width:0;height:0;border-right:10px solid  #FAEAD0;border-bottom:10px solid transparent;border-top:10px solid transparent;"></div>
                  <div class="textClass" >{{$t('datapermission.induction.inductionFamily.emergencyContacts')}}</div>
                </div>
              </div>
            </a-col>
          </a-row>




        </div>
      </a-collapse-panel>
      <!-- 特别说明 ---------------------------------------------------------------------------------------------------------------------->
      <a-collapse-panel  class="panelHeader" key="5" :style="panelStyle" :showArrow="false" >
        <div slot="header"  :class="userFlag ? 'copEducationUSer' : 'copEducation'">
          <div style="width: 12px;height: 12px;background: #FABE00;border-radius: 50%;margin-left: 9px"></div>
          <div style="font-size: 14px;color: #333333;font-weight: 600;margin-left: 10px;display: flex;justify-content: space-between;width: 100%;align-items: center">
            {{$t('datapermission.induction.specialNote')}}
            <a-icon  type="caret-right" :rotate="activeKey.indexOf('5')>-1 ? 90 : -90" style="margin-right: 16px"/>
          </div>
        </div>
        <div :class="userFlag ? 'copEducationContentUser' : 'copEducationContent'" >
          <a-row style="padding: 23px">
            <a-col :span="24">
              <div style="display: flex;margin-bottom: 10px;">
                <div style="font-size: 12px;color: #333333;letter-spacing: 0;">
                  {{$t('datapermission.induction.remarks')}}
                </div>
                <div style="margin-left: 50px">
                  <a-radio-group v-model="inductionInfo.inductionInvitationDO.isPeer">
                    <a-radio v-if="inductionInfo.inductionInvitationDO.isPeer == 1" :value="1">{{$t('mansion.deleteMansionOwnerModal.button.yes')}}</a-radio>
                    <a-radio v-if="inductionInfo.inductionInvitationDO.isPeer == 2" :value="2">{{$t('mansion.deleteMansionOwnerModal.button.no')}}</a-radio>
                  </a-radio-group>
                </div>
              </div>
            </a-col>
            <a-col :span="24">
              <div style="font-size: 12px;color: #333">
                {{inductionInfo.inductionInvitationDO.specialNote}}
              </div>
            </a-col>

          </a-row>
        </div>
      </a-collapse-panel>
    </a-collapse>
  </div>

</template>

<script>

  import indctionApi from '@/api/sys/inductionInvitation'
  import moment from 'moment'
  export default {
    name: 'inductionModal',

    data(){
      return{
        activeKey:['1','2','4',"5"],
        panelStyle: 'background: #FFFFFF !important;border: 0;',
        inductionInfo:{
          inductionInvitationDO:{},
          inductionBasicDO:{},
          inductionTreatmentDO:{},
          inductionDeclare:{},
          inductionWorkList:[],
          inductionEducationList:[],
          inductionFamily:[],
          relationshipName:[]
        }
      }
    },
    props: {
      yearSalary:{},
      month:{},
      userInfo: {
        type: Object
      },
      empBrokerageInfo:{},
      empInsuranceStandard:{},
      userFlag:{
        type: Boolean,
        default:false
      }
    },
     mounted() {

     },
    computed:{
      linkusers(){
       let arr =  this.inductionInfo.inductionFamily.filter(o=>o.emergencyContact == 1 )
        if(arr){
          return arr[0];
        }else{
          return {}
        }
      },
      isShowDetail(){
        let permissions = this.$store.getters.roles.permissions
        if(permissions instanceof Array){
          if(permissions.indexOf("EMPLOYEECONTROLLER_LOOKDETAIL") != -1){
            return true;
          }
        }
        return false;
      },
      isShowOther(){
        let permissions = this.$store.getters.roles.permissions
        if(permissions instanceof Array){
          if(permissions.indexOf("EMPLOYEECONTROLLER_LOOKTREATMENTINFORMATION") != -1){
            return true;
          }
        }
        return false;
      },
      isShowAll(){
        let permissions = this.$store.getters.roles.permissions
        if(permissions instanceof Array){
          if(permissions.indexOf("EMPLOYEECONTROLLER_LOOKALL") != -1){
              return true;
          }
        }
        return false;
      },
    },
    methods:{
      moment,
      getEducationDate(data){
        let dates = data.split(',')
        if(dates.length > 1 ){
          return dates[0]+'至'+dates[1]
        }else{
          return data
        }
      },
      initInduction(){
        console.log("初始化")
        this.inductionId = this.userInfo.inductionId
        if(this.inductionId != undefined && this.inductionId!=0){
          indctionApi.selectDetail(this.inductionId).then(res => {
            if(res.code == 1){
              console.log('res.data',res.data)
              this.inductionInfo = res.data
            }
          })
        }
      },
      collapseChanges(allActiveKey){
        this.activeKey = allActiveKey
      },

      getArrayList(value){
        if(value == '~'){
          return value;
        }
        try{
          let arr = JSON.parse(value)
          return arr[0]+" / "+arr[1];
        }catch (e) {
          return '~'
        }
      },
      getNativeName(row){
        let nativeName;
        let natives =  this.$t('datapermission.induction.native')
        natives.forEach((item,index) => {
          if(row == item.id){
            nativeName = item.name
          }
        })
        return nativeName
      },
    }



  }
</script>

<style scoped lang="less">

  .colName{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    overflow: hidden;
  }

  .labelName{
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
  }

  .valueName{
    width: 150px;
    font-size: 12px;
    color: #333333;
    letter-spacing: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space:nowrap;
  }

  .textClass{
    display: flex;
    align-items: center;
    padding: 0 10px 0 10px;
    height: 19px;
    border-radius: 0 3px 3px 0;
    font-size: 12px;
    color: #FA9B00;
    background-color:  #FAEAD0;
  }

  .top{
    width: 882px;
    height: 40px;
    background: #FAFBFC;
    margin: 20px 0 10px 25px ;
    display: flex;
    flex-direction: row;
    align-items: center
  }
  .topUser{
    width: 882px;
    height: 40px;
    background: #FAFBFC;
    margin: 20px 0 10px 40px ;
    display: flex;
    flex-direction: row;
    align-items: center
  }

  .context{
    width: 882px;
    background: #FAFBFC;
    margin-left: 25px;
    padding-bottom: 10px;
  }
  .contextUser{
    width: 882px;
    background: #FAFBFC;
    margin-left: 40px;
    margin-right: 40px;
    padding-bottom: 10px;
  }

  .copPanel{
    width: 882px;
    height: 40px;
    background: #FAFBFC;
    margin: 10px 0 0 13px ;
    display: flex;
    flex-direction: row;
    align-items: center
  }

  .copPanelUser{
    width: 882px;
    height: 40px;
    background: #FAFBFC;
    margin: 10px 0 0 28px ;
    display: flex;
    flex-direction: row;
    align-items: center
  }


  .copContent{
    width: 882px;
    background: #FAFBFC;
    margin-left: 9px;
  }

  .copContentUser{
    width: 882px;
    background: #FAFBFC;
    margin-left: 24px;
    margin-top: -15px
  }

  .copEducation{
    width: 882px;
    height: 40px;
    background: #FAFBFC;
    margin: -5px 0 0 13px ;
    display: flex;
    flex-direction: row;
    align-items: center
  }

  .copEducationUSer{
    width: 882px;
    height: 40px;
    background: #FAFBFC;
    margin: -5px 0 0 28px ;
    display: flex;
    flex-direction: row;
    align-items: center
  }

  .copEducationContentUser{
    width: 882px;
    height: auto;
    background: #FAFBFC;
    margin-left: 24px;
    margin-top: -15px;
    padding-bottom: 18px
  }
  .copEducationContent{
    width: 882px;
    height: auto;
    background: #FAFBFC;
    margin-left: 9px;
    margin-top: -15px;
    padding-bottom: 18px
  }

  .phone{
    display: flex;flex-direction: row;margin-left: 20px
  }
  .phoneUser{
    display: flex;flex-direction: row;margin-left: 10px
  }


</style>